import api from './api';

export interface Colunas {
  title: string
  dataIndex: string
}

export interface PerfilAcesso {
  id: string;
  descricao: string;
  nome: string;
  nomeColunas: Colunas[]
  dataTable: any[]
}

export interface PutModuloPerfil {
  moduloId: string,
  tipoModuloId: string,
  perfilId: string,
  checked: boolean
}

export const getAllPerfil = () => api.get<PerfilAcesso[]>('perfilAcesso');

export const getAllPerfilFornecedor = () => api.get<PerfilAcesso[]>('perfilAcesso/fornecedor');
export const getAllPerfilFornecedorOptions = () =>
  getAllPerfilFornecedor().then(perfil => (perfil || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const getAllPerfilMrn = () => api.get<PerfilAcesso[]>('perfilAcesso/mrn');
export const getAllPerfilMrnOptions = () =>
  getAllPerfilMrn().then(perfil => (perfil || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const createUser = (perfilAcesso: PerfilAcesso) => api.post<PerfilAcesso>('perfilAcesso', perfilAcesso);
export const Get = (id: string) => api.get(`perfilAcesso/${id}`);

export const getAllPerfilComModulo = () => api.get<PerfilAcesso[]>('perfilAcesso/getAllPerfilComModulo');

export const getAllPerfilComModuloByPerfilId = (id: string) => api.get<PerfilAcesso>(`perfilAcesso/getAllPerfilComModuloByPerfilId/${id}`);


export const putUpdateModuloPerfil = (form: PutModuloPerfil) => api.put<boolean>('perfilAcesso/updateModuloPerfil', form)